export default {"src":"/_next/static/media/throttle-transition.75a4fb9a.svg","height":23,"width":228,"blurWidth":0,"blurHeight":0};